module.exports = __webpack_public_path__ + "static/media/Asset 55.21656bd7.jpg";